import { render, staticRenderFns } from "./WeddingInvitation.vue?vue&type=template&id=e4e4179c&"
import script from "./WeddingInvitation.vue?vue&type=script&lang=js&"
export * from "./WeddingInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports